import React, { useEffect, useState } from 'react'
import firebase from 'firebase/app';
import 'firebase/messaging';
import { getToken } from '../CloudFb';
import axios from 'axios';

import "../style.css"
import { isAutheticated, signup, updateUser, signout } from './Helper';
import { Link, Redirect, useHistory } from "react-router-dom";
import { flushSync } from 'react-dom';




// function Sub() {

//     const [token, setToken] = useState()

//     useEffect(() => {
//         // const messaging = firebase.messaging();
//         // messaging.getToken({ vapidKey: "BD37lnV-o4oRp8mRrabPF17lPWCwvKlEAPwGVRK7RZxqlZX3L-R5FSZnCTpTC66t0sgiDIxd9iWiFHPaVq8U-p4"});

//         // mes()
//     }, [])

//     // const mes = () => {
//     //     const messaging = firebase.messaging();
//     //     messaging.requestPermission()
//     //         .then(() => {
//     //             console.log("have permission");
//     //             return messaging.getToken();
//     //         }).then((token) => {
//     //             console.warn("token", token)
//     //             setToken(token)
//     //         })
//     //         .catch((err) => {
//     //             console.log("Error");
//     //         })
//     //     messaging.onMessage(function (payload) {
//     //         console.log("message", payload);
//     //     })
//     // }

//     return (
//         <div>
//             <h1>hii</h1>
//             <Pincode cityInput={{width:'500px'}}/>

//         </div>
//     )
// }

// export default Sub


const Sub = () => {
    const { id, email } = isAutheticated();
    const [fcm, setFcm] = useState("")
    const [fcmD, setFcmD] = useState("")
    const [tokenError, setTokenError] = useState(false)
    const [values, setValue] = useState(
        {
            pincode: "",
            city: "",
            district: "",
            state: "",
            error: "",
            didRedirect: false,
            success: false
        }
    )
    const { pincode, city, district, state, error, success, didRedirect } = values;
    const messaging = firebase.messaging();


    const getToken = (setTokenFound) => {
        return messaging.getToken({ vapidKey: 'BD37lnV-o4oRp8mRrabPF17lPWCwvKlEAPwGVRK7RZxqlZX3L-R5FSZnCTpTC66t0sgiDIxd9iWiFHPaVq8U-p4' }).then((currentToken) => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);
                setFcm(currentToken)
                // setTokenFound(true);
                // Track the token -> client mapping, by sending to backend server
                // show on the UI that permission is secured
            } else {
                console.log('No registration token available. Request permission to generate one.');
                // setTokenFound(false);
                // shows on the UI that permission is required 
            }
        }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
            // catch error while creating client token
        });
    }



    const mes = () => {
        const messaging = firebase.messaging();
        // messaging.getToken({ vapidKey: "BD37lnV-o4oRp8mRrabPF17lPWCwvKlEAPwGVRK7RZxqlZX3L-R5FSZnCTpTC66t0sgiDIxd9iWiFHPaVq8U-p4" });
        messaging.requestPermission()
            .then(() => {

                console.log("have permission");
                return messaging.getToken();
            }).then((token) => {
                console.log("token", token)
                setFcm(token)
            })
            .catch((err) => {
                setTokenError(true)
                console.log("Error");
            })
        messaging.onMessage(function (payload) {
            console.log("message", payload);
        })
    }




    // const fcmtoken = () => {
    //     messaging.getToken().then(
    //         (data) => {
    //             console.log("tokenData", data);
    //             setFcm(data)
    //         }
    //     )
    // }

    useEffect(() => {

        // mes()
        getToken()
        // getToken()
    }, [])

    const alertBox = () => {
        alert("Allow Notification Permission ")
    }


    if (tokenError) {
        alertBox()
    }

    const onSubmit = async event => {
        event.preventDefault();
        // setValue({ ...values, error: false });
        await updateUser(email, { email, fcm, aboutME: fcmD, pincode, city, district, state })
            .then(data => {
                if (data.error) {
                    console.log(data.error);
                } else {
                    setValue({
                        ...values,
                        pincode: "",
                        city: "",
                        district: "",
                        state: "",
                        error: "",
                        success: true
                    });
                }
            })
        // .catch(console.log("Error in signup"));
    };

    // const retry = () => {
    //     return (
    //         <div>
    //             <h1>allow the permission</h1>
    //             <Link onClick={() => { reqPer() }}> retry</Link>
    //         </div>
    //     )
    // }

    const successMessage = () => {
        return (
            <div className="row">
                <div className="col-md-6 offset-sm-3 text-left mb-5">
                    <div
                        className="alert alert-success"
                        style={{ display: success ? "" : "none" }}
                    >
                        Update PinCode successfully.
                        You get Push notification and Email
                    </div>
                </div>
            </div>
        );
    };
    const form = () => {
        return (
            <form onSubmit={onSubmit}>
                <div className="outer_box">
                    {error ? (
                        <span className="error-display">{error}</span>
                    ) : null}
                    <div className="group">
                        <input
                            maxLength={6}
                            minLength={6}
                            onChange={e => onChange(e)}
                            name="pincode"
                            placeholder=" "
                            value={pincode}
                            id="pincode"
                            type="number"
                            // style={this.props.pincodeInput}
                            class="pin"
                            required
                        />
                        <span class="highlight"></span>
                        <label>Pin code</label>
                    </div>
                    <div className="group">
                        <input
                            minLength={2}
                            type="String"
                            readonly
                            placeholder=" "
                            value={city}
                            // style={cityInput}
                            class="inp"
                            required
                        />
                        <label>City</label>
                    </div>
                    <div className="group">
                        <input
                            minLength={2}
                            type="String"
                            placeholder=" "
                            readonly
                            value={district}
                            // style={districtInput}
                            class="inp"
                            required
                        />
                        <label>District</label>
                    </div>
                    <div className="group">
                        <input
                            minLength={2}
                            type="String"
                            placeholder=" "
                            readonly
                            value={state}
                            // style={stateInput}
                            class="inp"
                            required
                        />
                        <label>State</label>
                    </div>
                    <button className="btn btn-block btn-success mb-4" type="submit" >Submit</button>
                </div>
            </form>
        )
    }







    const onChange = (e) => {
        setValue({ [e.target.name]: e.target.value });
        if (e.target.value.length === 6) {
            setValue({
                error: ""
            });
            axios
                .get(`https://api.postalpincode.in/pincode/${e.target.value}`)
                .then(res =>
                    setValue({
                        pincode: e.target.value,
                        state: res.data[0].PostOffice[0].State,
                        city: res.data[0].PostOffice[0].Block,
                        district: res.data[0].PostOffice[0].District
                    })
                )
                .then(() => {
                    document.getElementById("pincode").classList.remove("error");
                })
                .catch(err => {
                    document.getElementById("pincode").className = "error";
                    setValue({
                        error: "Invalid PIN Code"
                    });
                });
        }
        if (e.target.value.length !== 6) {
            setValue({
                city: "",
                district: "",
                state: "",
                error: "PIN code must be of 6 digits"
            });
        }
    }

    return (
        <div>
            {/* <button className="btn btn-sm btn-warning" onClick={() => {
                signout(() => {
                    <Redirect to="/" />
                });
            }}>logout</button> */}
            <h1 className="App text-white" >Enter Your City Pincode</h1>
            {successMessage()}

            {form()}

        </div>
    );

}
export default Sub
